import { DAYS_OPTIONS, HOSTS } from "@/constants";
import { type AxiosResponse, httpClient } from "@/services/httpClient";
import { FrequencyType } from "@/types/cpe";
import { rrulestr } from "rrule";

const allowedRelation = ["variables", "alerts", "graphs", "formulas"];
const allowedSubRelation = ["dashboards"];
export interface Itags {
  type: etag;
  value: string;
}
export type etag = "info" | "warning" | "danger" | "primary" | "success";
export type buttonType =
  | ""
  | "text"
  | "default"
  | "primary"
  | "success"
  | "warning"
  | "info"
  | "danger";
export const formateScenarioHours: any = (hoursOfDay: boolean[]) => {
  if (hoursOfDay.length == 0) return null;
  const validHours: number[] = hoursOfDay
    .map((ho: boolean, index: number) => {
      return ho ? Array.from(Array(24).keys())[index] : ho;
    })
    .filter((dw: boolean | number) => dw !== false)
    .map((hour: boolean | number) => {
      return hour as number;
    });
  return `${validHours[0]}h ↔ ${validHours[validHours.length - 1] + 1}h`;
};

export const formateScenarioDays: any = (daysOfWeek: boolean[]) => {
  return daysOfWeek
    .map((dw: boolean, index: number) => {
      return dw ? DAYS_OPTIONS[index] : dw;
    })
    .filter((dw: boolean | string) => !!dw)
    .map((day: boolean | string) => {
      return (day as string).slice(0, 3);
    })
    .join(", ");
};

export const getTruncateLenght: any = (
  interfaceWidth: any,
  minTruncateLength: number,
) => {
  const width = parseInt(interfaceWidth);
  const exp = Math.exp(width / 100);
  const invert = (1 / exp) * 100;
  const result = Math.floor(exp - invert);
  return result > minTruncateLength ? result : minTruncateLength;
};

export const formatNumbers: any = (num: number, flow: number) => {
  return `${num?.toFixed(flow)}`;
};

export const measureText: any = (pText: string) => {
  let lDiv = document.createElement("div") as any;
  document.body.appendChild(lDiv);
  lDiv.style.fontSize = "12px";
  lDiv.style.position = "absolute";
  lDiv.style.left = -1000;
  lDiv.style.top = -1000;
  lDiv.textContent = pText;

  const lResult = lDiv.clientWidth;

  document.body.removeChild(lDiv);
  lDiv = null;

  return lResult;
};

export const translateStatusFromEnglishToFrench: any = (status: string) => {
  switch (status) {
    case "new":
      return "Nouveau";
    case "fixed":
      return "Traité action corrective";
    case "fixed_no_action":
      return "Traité sans suite";
    case "seen":
      return "Vu";
    default:
      return "Statut non identifié";
  }
};

export const formatTree: any = (nodeArray: any[], nodeName: any) => {
  return {
    name: `${nodeName.charAt(0).toUpperCase()}${nodeName.slice(1)} (${
      nodeArray.length
    })`,
    children: [...nodeArray]
      .filter((node: any) => typeof node === "object" && node !== null)
      .map((node: any) => {
        const arrays = [...Object.keys(node)]
          .filter((key: string) => Array.isArray(node[key]))
          .filter((key: string) => node[key].length > 0)
          .filter((key: string) => allowedSubRelation.indexOf(key) !== -1);
        return {
          name: node.name || node.label || node.measure_name,
          children:
            arrays.length > 0
              ? [...arrays].map((key: any) => {
                  return formatTree(node[key], key);
                })
              : [],
        };
      }),
  };
};

export const formatObjectRelation: any = (relationObject: any) => {
  const keys = Object.keys(relationObject);
  return [
    {
      name: relationObject.measure_name || relationObject.name,
      children: [...keys]
        .filter((key: string) => allowedRelation.indexOf(key) !== -1)
        .filter((key: string) => Array.isArray(relationObject[key]))
        .map((key: any, index: number) => {
          return {
            ...formatTree(relationObject[key], key),
            left: index % 2 === 0,
          };
        }),
    },
  ];
};

export const arraysEqual: any = (a: any[], b: any[]) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; ++i) {
    if (a[i].indexOf(b[i]) === -1) return false;
  }
  return true;
};

export const containNulls: any = (nullArray: any[]) => {
  return nullArray.some((el: any) => el.value === null);
};

export const noNullInArray: any = (nullArray: any[]) => {
  const durtyArray = [...nullArray];
  if (containNulls(durtyArray)) {
    for (const [index, durtyElement] of [...durtyArray].entries()) {
      if (durtyElement.value === null) {
        if (index === 0) {
          durtyArray[index].value = 0;
        } else {
          for (let i = index; i > 0; i--) {
            if (durtyArray[i].value !== null) {
              durtyArray[index].value = durtyArray[i].value;
              i = 1;
            }
          }
        }
      }
    }
  }
  return [...durtyArray];
};

export const isExist = (item: any) => {
  return item != null && item != undefined && Object.keys(item).length > 0;
};

const excludedClientNames = ["ELEVEURS DE LA CHAMPAGNE", "SEAVALUE"];
const excludedProjectNames = [
  "ELEVEURS DE LA CHAMPAGNE - Caurel",
  "SEA VALUE Lignol",
  "SEA VALUE Lignol ",
];

function excludeEntities(
  data: any,
  clientNames: string[],
  projectNames: string[],
): any {
  return data.filter((item: any) => {
    if (
      clientNames.includes(
        item.client?.name ||
          item.project?.place?.client?.name ||
          item.project?.client?.name ||
          item?.name,
      )
    ) {
      return false;
    }

    // Check for project name exclusion
    if (projectNames.length > 0 && item.projects) {
      if (
        item.projects.some((project: any) =>
          projectNames.includes(project.name),
        )
      ) {
        return false;
      }
    } else if (
      projectNames.length > 0 &&
      projectNames.includes(item.project?.name || item?.name)
    ) {
      return false;
    }

    return true;
  });
}

export function excludeClient(data: any) {
  const result = excludeEntities(data, excludedClientNames, []);

  return result;
}
export function excludeProject(data: any) {
  const result = excludeEntities(data, [], excludedProjectNames);
  return result;
}

export function excludeProjectAndClient(data: any) {
  return excludeEntities(data, excludedClientNames, excludedProjectNames);
}

export function excludeProjectAndClientVariable(data: any) {
  return excludeEntities(data, excludedClientNames, excludedProjectNames);
}

export function excludeProjectAndClientDashboard(data: any) {
  return excludeEntities(data, excludedClientNames, excludedProjectNames);
}

export function formatBooleanToYesNo(value: boolean) {
  if (value === true) {
    return "Oui";
  } else if (value === false) {
    return "Non";
  }
  return "---";
}

export function splitUserName(username: string) {
  return username.split(/[\s.]+/);
}

export function downloadAwsFile(
  url: string,
  id: string,
  endpoint: string,
  isUrl = false,
) {
  return new Promise((resolve, reject) => {
    httpClient
      .get(`${HOSTS.AWS}/${url}/${id}/${endpoint}`)
      .then((response: AxiosResponse<any>) => {
        // Check if we have a valid response with downloadUrl
        if (response?.data?.url) {
          if (isUrl) {
            resolve(response?.data?.url);
            return;
          }
          // Check if the URL looks valid (basic check)
          const urlPattern = /^https?:\/\/.+/i;
          if (!urlPattern.test(response.data.url)) {
            reject(new Error("Invalid download URL"));
          }

          // Create invisible iframe to handle download without page redirect
          const iframe = document.createElement("iframe");
          iframe.style.display = "none";
          document.body.appendChild(iframe);

          // Load URL in iframe
          if (iframe.contentWindow) {
            iframe.onload = () => {
              // Remove iframe after small delay to ensure download started

              reject(new Error("File not accessible"));
            };

            iframe.onerror = () => {
              document.body.removeChild(iframe);
              reject(new Error("Download failed"));
            };

            // Navigate iframe to download URL
            iframe.src = response.data.url;

            setTimeout(() => {
              resolve(null);
            }, 1000);
          }
        } else {
          reject(new Error("Download URL not found"));
        }
      })
      .catch((error) => {
        console.error("Download error:", error);
        // Check if it's an AWS XML error response
        if (
          error?.response?.headers?.["content-type"]?.includes(
            "application/xml",
          )
        ) {
          reject(new Error("File not accessible"));
        }
        reject(error);
      });
  });
}
export const convertDivToP = (html: string) => {
  return html.replace(/<div\b([^>]*)>/gi, "<p$1>").replace(/<\/div>/gi, "</p>");
};

export const freqToString = (interval: number) => {
  if (interval == 1) return FrequencyType[0];
  if (interval == 2) return FrequencyType[1];
  if (interval == 3) return FrequencyType[2];
};

export const rruleToObject = (rule: string) => {
  const rrule = rrulestr(rule);
  const frequency = freqToString(rrule.options.interval);
  const datesend = rrule.options.bymonthday;

  return {
    frequency,
    datesend,
  };
};

export const getErrorForm = (errors: any) => {
  const map: Record<string, boolean> = {};
  Object.keys(errors).forEach((field) => {
    map[field] = true;
  });
  return map;
};

export const formatNumber = (num: number) => {
  if (num === null || num === undefined) return "0";

  const absNum = Math.abs(num);
  let formatted = "";

  if (absNum >= 1_000_000_000) {
    formatted = (num / 1_000_000_000).toFixed(2) + "B";
  } else if (absNum >= 1_000_000) {
    formatted = (num / 1_000_000).toFixed(2) + "M";
  } else if (absNum >= 1_000) {
    formatted = (num / 1_000).toFixed(2) + "K";
  } else {
    formatted = num.toString();
  }

  return formatted.replace(/\.?0+([KMB])$/, "$1");
};

export const tagColor = (level: string): etag => {
  const tags: Itags[] = [
    { type: "info", value: "info" },
    { type: "warning", value: "warning" },
    { type: "danger", value: "error" },
    { type: "info", value: "critical" },
  ];
  const tag = tags.find((tag: any) => tag.value === level);

  return tag !== undefined ? tag.type : "info";
};

export const isStagnationOrOfflineSingleAlert = (alert: any): boolean => {
  return ["stagnation", "offline_single"].includes(
    alert?.activationFunction?.functionName,
  );
};
